import api from './api';

export const OrderService = {
  getAllOrders: async () => {
    const response = await api.get('/orders');
    return response.data;
  },
  
  getOrderById: async (id) => {
    const response = await api.get(`/orders/${id}`);
    return response.data;
  },
  
  createOrder: async (orderData) => {
    const response = await api.post('/orders', orderData);
    return response.data;
  },
  
  updateOrder: async (id, orderData) => {
    const response = await api.put(`/orders/${id}`, orderData);
    return response.data;
  },
  
  deleteOrder: async (id) => {
    const response = await api.delete(`/orders/${id}`);
    return response.data;
  },
  
  syncAmazonOrders: async () => {
    const response = await api.post('/orders/sync-amazon');
    return response.data;
  },
  
  syncSingleFulfillmentInfo: async (fulfillmentId) => {
    const response = await api.post(`/orders/sync-fulfillment-info/${fulfillmentId}`);
    return response.data;
  },
  
  getOrdersByStatus: async (status) => {
    const response = await api.get(`/orders?status=${status}`);
    return response.data;
  },

  exportOrderItemsCSV: async (params = {}) => {
    const response = await api.get('/orders/items/export-csv', {
      params,
      responseType: 'blob' // Important for file download
    });
    return response;
  }
};

export default OrderService;